export class EmailAddressEntity {
  id: number;
  email: string;
  description_En: string;
  description_Fr: string;

  constructor() {
    this.id = 0;
    this.email = '';
    this.description_En = '';
    this.description_Fr = '';
  }
}
